export const AI_PLANNER_GENERATED_BY = 'AI_PLANNER';

export const AI_PLANNER_SYNC_BYLINE_RESOLVER_PROCEDURE = 'artifact.resolveByConfluenceContentAri';
